<div class="search-result d-flex align-items-center justify-content-start gap-small cursor-pointer w-100">
  @if (isLoading()) {
    <common-app-services-frequent-services-preview
      [isLoading]="true"
      [showTitle]="false"
    ></common-app-services-frequent-services-preview>
    <lib-ngx-skeleton-loading
      [height]="'20px'"
      [width]="'50px'"
      [classes]="'radius-medium'"
    ></lib-ngx-skeleton-loading>
  } @else {
    <common-app-services-frequent-services-preview
      [frequentService]="service()"
      [showTitle]="false"
    ></common-app-services-frequent-services-preview>
    <div class="c-2 text-onback-medium">{{ service().title }}</div>
  }
</div>
